/**
 * Previous value reference hook
 * @param value - value to keep reference of the previous
 */
import { useEffect, useRef } from "react";
/**
 * usePrevious - holds previous value of any variable that can change
 * created based on various implementations (google usePrevious)
 * 4ex: https://medium.com/better-programming/8-awesome-react-hooks-2cb31aed4f3d
 * example:
 *    const [prop, setProp] = useState(1)
 *    const prevProp = usePrevious(prop);
 *
 *    useEffect(() => {
 *        // here prop changed and with pervProp help we can see what was the actual change
 *        if (prevProp > 0 && prop === 0) {
 *         ... // this only happens if prop was positive before and now it is 0
 *        }
 *    }, [prop])
 *
 * @param value
 */
export const usePrevious = (value) => {
    // miscellaneous container whose prop is mutable - holds any value
    const ref = useRef();
    // add effect - if anything is updated - save the value in the ref
    useEffect(() => {
        ref.current = value;
    }, [value]);
    // Return previous value (happens before update in useEffect above)
    return ref.current;
};
//# sourceMappingURL=usePrevious.js.map